export const config = {
  brand: {
    name: "BPA Solutions",
    websiteLabel: "www.bpasolutions.au",
    websiteUrl: "https://www.bpasolutions.au",
    email: "support@bpasolutions.au",
    phone: "+61 425 228 778",
    location: "Sydney, Australia",
    bookingLink: "https://tidycal.com/anishmmalhotra/initial-20-minutes-discussion"
  },
  media: {
    transformationImage: {
      src: "https://images.unsplash.com/photo-1599643477877-530eb83abc8e?q=80&w=1000&auto=format&fit=crop",
      alt: "Editorial jewellery close-up showing premium BPA Solutions visual transformation"
    },
    videoShowcasePrimary: {
      src: "https://cdn1.sharemyimage.com/smi/2026/05/26/n2-video.mp4",
      poster: "https://images.unsplash.com/photo-1620656798579-1984d9e87df5?q=80&w=1600&auto=format&fit=crop",
      alt: "Dynamic try-on style jewellery video created by BPA Solutions"
    },
    finalCtaBackground: {
      src: "https://images.unsplash.com/photo-1599643478524-fb66f70a00bf?q=80&w=2000&auto=format&fit=crop",
      alt: "Jewellery background texture"
    }
  },
  proofSets: [
    {
      id: "Proof Set 1",
      category: "Earrings",
      title: "Earring Transformation",
      rawImage: {
        key: "proofSet1RawImage",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/eb9103ef-4b33-4fed-a98b-9a51b367bef7-0127ebdfd6310e4ef364343e7389ac6a.jpg",
        alt: "Original product reference for earrings before BPA Solutions visual transformation",
        label: "Original Product Reference",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      },
      polishedImage: {
        key: "proofSet1PolishedImage",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/8dafc851a4b44daaa55b34bb6985a225.png",
        alt: "Finished product image for earrings created by BPA Solutions",
        label: "Finished Product Image",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      },
      video: {
        key: "proofSet1TryOnVideo",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/3276e9ee931a421bbb9037422b62d751.mp4",
        poster: "https://cdn1.sharemyimage.com/smi/2026/05/26/8dafc851a4b44daaa55b34bb6985a225.png",
        alt: "Product video preview for earrings created by BPA Solutions",
        label: "Product Video Preview",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      }
    },
    {
      id: "Proof Set 2",
      category: "Ring",
      title: "Ring Transformation",
      rawImage: {
        key: "proofSet2RawImage",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/Ring1.png",
        alt: "Original product reference for ring before BPA Solutions visual transformation",
        label: "Original Product Reference",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      },
      polishedImage: {
        key: "proofSet2PolishedImage",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/Ring2.png",
        alt: "Finished product image for ring created by BPA Solutions",
        label: "Finished Product Image",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      },
      video: {
        key: "proofSet2TryOnVideo",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/ring-video.mp4",
        poster: "https://cdn1.sharemyimage.com/smi/2026/05/26/Ring2.png",
        alt: "Product video preview for ring created by BPA Solutions",
        label: "Product Video Preview",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      }
    },
    {
      id: "Proof Set 3",
      category: "Necklace",
      title: "Necklace Transformation",
      rawImage: {
        key: "proofSet3RawImage",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/ChatGPT-Image-May-26-2026-02_38_31-PM.png",
        alt: "Original product reference for necklace before BPA Solutions visual transformation",
        label: "Original Product Reference",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      },
      polishedImage: {
        key: "proofSet3PolishedImage",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/99672ed91efd44c98f87135c38b46e58.png?v=2",
        alt: "Finished product image for necklace created by BPA Solutions",
        label: "Finished Product Image",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      },
      video: {
        key: "proofSet3TryOnVideo",
        src: "https://cdn1.sharemyimage.com/smi/2026/05/26/d04527b3996f4bfc8c57203f06bcfced.mp4",
        poster: "https://cdn1.sharemyimage.com/smi/2026/05/26/99672ed91efd44c98f87135c38b46e58.png?v=2",
        alt: "Product video preview for necklace created by BPA Solutions",
        label: "Product Video Preview",
        recommendedSize: "1080x1920",
        aspectRatio: "9:16",
        layout: "vertical-proof-frame"
      }
    }
  ],
  challenges: [
    {
      id: 1,
      problem: "Look premium without a full production team.",
      solution: "You do not need photographers, stylists, editors and video specialists to create stronger product visuals.",
      benefit: "BPA Solutions gives your jewellery brand a more polished online presence without the overhead of a creative department."
    },
    {
      id: 2,
      problem: "Turn product references into polished assets.",
      solution: "Send the original product photo or product page reference, and BPA Solutions handles the finished visual output.",
      benefit: "Your basic reference becomes a premium asset for product pages, campaigns and customer trust."
    },
    {
      id: 3,
      problem: "Show scale, fit and presentation more clearly.",
      solution: "Create finished visuals and video previews that help shoppers understand how your jewellery looks and presents.",
      benefit: "Customers feel more confident before they enquire or buy."
    },
    {
      id: 4,
      problem: "Launch collections without waiting on a studio shoot.",
      solution: "Use a faster done-for-you visual workflow for new drops, bestsellers and seasonal promotions.",
      benefit: "You can prepare stronger campaign visuals without coordinating models, photographers or studio bookings."
    },
    {
      id: 5,
      problem: "Make your brand feel larger and more established.",
      solution: "Upgrade your product presentation so the store feels more refined, consistent and premium.",
      benefit: "First-time visitors see a jewellery brand that feels serious, trustworthy and ready to buy from."
    },
    {
      id: 6,
      problem: "Support a higher price point with stronger presentation.",
      solution: "Create visuals that better match the quality, craftsmanship and value of your jewellery pieces.",
      benefit: "Your online experience feels more aligned with premium pricing."
    },
    {
      id: 7,
      problem: "Create more content from each product reference.",
      solution: "Use finished images and product video previews across product pages, ads, email campaigns and social media.",
      benefit: "One product reference can support multiple customer touchpoints."
    },
    {
      id: 8,
      problem: "Avoid learning complex creative tools yourself.",
      solution: "You do not need to master AI tools, image editing, video formatting or ecommerce asset preparation.",
      benefit: "BPA Solutions handles the technical and creative production so your team can stay focused on sales."
    },
    {
      id: 9,
      problem: "Get a done-for-you visual workflow.",
      solution: "Share the product reference and BPA Solutions creates premium finished images and product video previews.",
      benefit: "Small jewellery teams get a simple way to look premium online without managing another complicated platform."
    }
  ],
  process: [
    {
      step: "01",
      title: "Send Your References",
      description: "Provide us with your product links, rough references, or simple product photos."
    },
    {
      step: "02",
      title: "Creative Production",
      description: "Our team crafts ultra-premium model-wearing visuals and try-on videos."
    },
    {
      step: "03",
      title: "Receive Premium Assets",
      description: "Editorial-quality imagery and video files ready to deploy across your channels."
    }
  ],
  pricing: [
    {
      tier: "Starter Proof Pack",
      priceText: "From $297 AUD",
      description: "Perfect for testing our quality on your best-selling pieces.",
      features: [
        "3 Premium Model Visuals",
        "1 Short Try-On Video",
        "High-Resolution Delivery",
        "7-Day Turnaround"
      ],
      tag: "Starter",
      buttonText: "Get Started",
      checkoutUrl: ""
    },
    {
      tier: "Product Page Upgrade",
      priceText: "From $697 AUD",
      description: "Complete visual sets for up to 5 core products.",
      features: [
        "15 Premium Model Visuals",
        "5 Short Try-On Videos",
        "Scale & Fit References",
        "Commercial Usage Rights"
      ],
      tag: "Popular",
      buttonText: "Upgrade Store",
      checkoutUrl: ""
    },
    {
      tier: "Collection Launch Pack",
      priceText: "From $1,997 AUD",
      description: "Full editorial visual suite for a new collection launch.",
      features: [
        "Up to 25 Product Variations",
        "Campaign Hero Visuals",
        "Social-Ready Video Assets",
        "Priority Production"
      ],
      tag: "Premium",
      buttonText: "Secure Launch",
      checkoutUrl: ""
    },
    {
      tier: "Monthly Visual Retainer",
      priceText: "From $1,250 AUD/mo",
      description: "Ongoing visual production for high-growth brands.",
      features: [
        "Share Product Links or Reference Images",
        "Monthly Content Batching",
        "Dedicated Creative Lead",
        "Ad Account Creative Refresh"
      ],
      tag: "Ongoing",
      buttonText: "Partner With Us",
      checkoutUrl: ""
    }
  ],
  locations: [
    {
      state: "New South Wales",
      displayGroups: [
        {
          groupName: "Sydney Metro",
          suburbs: ["Sydney CBD", "Surry Hills", "Paddington", "Bondi", "Manly"]
        }
      ]
    },
    {
      state: "Victoria",
      displayGroups: [
        {
          groupName: "Melbourne Metro",
          suburbs: ["Melbourne CBD", "South Yarra", "Fitzroy", "Richmond", "St Kilda"]
        }
      ]
    }
  ],
  faq: [
    {
      question: "What does BPA Solutions create for jewellery ecommerce brands?",
      answer: "We create editorial-grade model-wearing jewellery images, product page visuals, campaign assets, and try-on style videos designed specifically for ecommerce stores."
    },
    {
      question: "Can you create model-wearing jewellery images from existing product photos?",
      answer: "Yes, we specialize in taking your existing product photos, CAD renders, or website links and transforming them into high-end model visuals without needing a physical studio shoot."
    },
    {
      question: "Can you create jewellery try-on style videos?",
      answer: "Absolutely. We produce short, dynamic try-on style motion videos that showcase the drape, scale, and sparkle of your jewellery pieces—perfect for social media and product pages."
    },
    {
      question: "Can the visuals be used on Shopify or WooCommerce?",
      answer: "Yes, all visuals are delivered in web-ready formats and high resolutions, making them perfectly optimized for Shopify, WooCommerce, and other major ecommerce platforms."
    },
    {
      question: "Do you work with brands outside Sydney?",
      answer: "Yes, while we are based in Sydney, we work with jewellery brands across Australia—including Melbourne, Brisbane, Perth, Adelaide, and Hobart—as well as international clients."
    },
    {
      question: "How do jewellery brands start with a small sample?",
      answer: "You can request a visual sample by sending us a product link or hero item reference. We will provide a proof set to demonstrate our quality before you commit to a larger package."
    },
    {
      question: "Do we need to book a model or photographer?",
      answer: "No, our service is completely done-for-you. We handle all creative production, eliminating the need for expensive agency models, photographers, and studio hire."
    },
    {
      question: "What file types can be supplied?",
      answer: "We can work with standard image files (JPG, PNG), raw photography files, high-quality CAD renders, or simply direct links to your existing product pages."
    },
    {
      question: "Can visuals be used for ads, email and social media?",
      answer: "Yes, we provide full commercial usage rights, allowing you to use the imagery and videos across paid advertising, email marketing campaigns, and social media platforms."
    },
    {
      question: "How quickly can a sample be created?",
      answer: "Sample creation is typically very fast. Once we review your reference and confirm the styling direction, initial visual proofs are usually ready within a few days."
    }
  ]
};